import { MaterialConfiguration } from './material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
export class EbookCardConfiguration extends MaterialConfiguration {
    constructor(course: any) {
        super();
        this.tagType = 'ebook';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/ebook.png';
        this.classType = 'eBook';
        this.multiContent = false;
        this.subtitle = 'branded.portal.courses.assignment.material.ebook.subtitle';
        this.expired = !course.enabled;
        this.clickable = !this.expired;
        this.action = LinkActions.DOWNLOAD;
        this.links = [{
                disabled: this.expired,
                tooltip: this.expired ? 'branded.portal.courses.assignment.ebook.download.tooltip' : null,
                url: this.expired ? '' : course.downloadLink,
                text: 'branded.portal.courses.assignment.ebook.download.text',
                type: LinkActions.DOWNLOAD,
                image: this.expired ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg' :
                    'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg'
            }];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/ebook-card-configuration.ts